import React, { Component } from "react";

import style from "./style.module.css";

export default class MenuSeparator extends Component {
  render() {
    return <div className={style.separator} />;
  }
}
